import { mapState } from "vuex";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export const companyInWeb = {
  data() {
    return {
      viewTitle: this.$t("message.companyProfile.tab.termsInBrowsers"),
      loading: false,
      loaded: false,
      dialog: {
        deleteKeyword: false
      },
      newKeyword: "",
      keywordToDelete: null
    };
  },

  computed: {
    ...mapState({
      keywords: state => state.keywords.keywords,
      keywordsScope: state => state.keywords.scope,
      company: state => state.company.company
    })
  },

  async created() {
    this.loading = true;

    await this.getKeywords();
    this.loading = false;
    this.loaded = true;
  },

  beforeRouteLeave(to, from, next) {
    if (!["wizard-step-2", "visibility-business-addresses"].includes(to.name)) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.WIZARD_COMPLETE,
        action: "abandoned",
        last_step: 3
      });
    }
    next();
  },

  methods: {
    async getKeywords() {
      this.loading = true;
      await this.$store.dispatch("keywords/fetchKeywords");
      this.loading = false;
    },

    getKeywordPayload(keyword) {
      // GTM event data collection below
      const gtmEventParams = {
        event: GTM_EVENT_NAME.WIZARD_KEYWORD_ADD,
        input_type: "company", // TODO: make dynamic when other scopes support provided
        keyword: keyword || null
      };

      this.$gtm.trackCustomEvent(gtmEventParams);
      // end GTM event stuff

      return { keyword: { name: keyword } };
    },

    async addKeyword() {
      if (!this.newKeyword) return;
      this.loading = true;

      await this.$store.dispatch(
        "keywords/addKeyword",
        this.getKeywordPayload(this.newKeyword)
      );

      this.newKeyword = "";
      this.loading = false;
    },

    handleDeleteKeywordClick(keyword) {
      this.keywordToDelete = keyword;
      this.dialog.deleteKeyword = true;
    },

    cancelDeletingKeyword() {
      this.keywordToDelete = null;
      this.dialog.deleteKeyword = false;
    },

    async deleteKeyword() {
      if (!this.keywordToDelete) return;
      this.dialog.deleteKeyword = false;
      this.loading = true;

      // GTM event data collection below
      const gtmEventParams = {
        event: GTM_EVENT_NAME.WIZARD_KEYWORD_REMOVE,
        input_type: "company", // TODO: make dynamic when other scopes support provided
        keyword:
          this.keywordToDelete && this.keywordToDelete.keyword
            ? this.keywordToDelete.keyword.name
            : null
      };

      this.$gtm.trackCustomEvent(gtmEventParams);
      // end GTM event stuff

      await this.$store.dispatch(
        "keywords/deleteKeyword",
        this.keywordToDelete.id
      );

      this.$notify({
        group: "default",
        type: "success",
        text: this.$t(
          "message.companyProfile.monitoredKeywords.chosenKeywordDeleted"
        )
      });

      this.keywordToDelete = null;
      this.loading = false;
    },

    async setWizardComplete() {
      await this.$store.dispatch("company/setWizardCompletionStatus", true);

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.WIZARD_STEP_3_KEYWORDS_ACTION,
        num_keywords: this.keywords.length
      });

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.WIZARD_COMPLETE,
        action: "finished",
        last_step: 3
      });

      this.$router.push({ name: "order-details" });
    }
  }
};
